import { render } from "./Enrolments.vue?vue&type=template&id=5e039abe"
import script from "./Enrolments.vue?vue&type=script&lang=js"
export * from "./Enrolments.vue?vue&type=script&lang=js"

import "./Enrolments.vue?vue&type=style&index=0&id=5e039abe&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__